import { ShoppingBag } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-border bg-surface mt-auto">
      <div className="container-page py-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2 text-text-secondary">
            <ShoppingBag className="h-5 w-5 text-primary" />
            <span className="font-semibold text-text">Katty Shop</span>
          </div>
          <p className="text-sm text-text-muted">
            &copy; {new Date().getFullYear()} Katty Shop. Все права защищены.
          </p>
        </div>
      </div>
    </footer>
  );
}
